import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Upload,
    Transfer,
    Form,
    Col,
    Rate,
    Divider,
    Radio,
    message,
    Popconfirm,
    Alert
} from 'antd';
import HtView from '../hetong/view'
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {DeleteOutlined, UploadOutlined, EditOutlined, PlusOutlined, PlusCircleOutlined} from '@ant-design/icons'
import moment from 'moment';

const {Option, OptGroup} = Select;
const {TextArea} = Input;
const {RangePicker} = DatePicker;

class Edit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                id: props.id,
            },
            visible: false,
            loading: false,
            loading2: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    sub() {
        let that = this
        that.setState({
            loading: true
        })
        let arr = that.state.condition
        // arr.type = that.props.type
        fetch('/Pay/import', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg);
                    this.props.refresh()
                    this.mdchange()
                } else {
                    message.error(data.msg)
                    that.setState({
                        loading: false,
                        list: data.err ? data.err : []
                    })
                }
            })
    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {

        } else {
            that.setState({
                condition: {},
                list: [],
                loading: false
            })
        }
    }

    // 上传图片
    picChange(name, info) {
        // console.log(info)
        if (info.file.status === 'uploading') {
            this.setState({loading2: true});
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // console.log(info.file.response)
            // return;
            var url = this.state.condition[name]
            if (info.file.response.status == 0) {
                message.error(info.file.response.msg)
                return;
            }
            url = info.file.response.url
            let data = Object.assign({}, this.state.condition, {[name]: url, filename: info.file.response.name})
            this.setState({
                condition: data,
                loading2: false,
            })
        }
    };

    render() {
        const columns = [
            {
                title: '错误信息',
                dataIndex: 'error',
                key: 'error',
                fixed: 'left'
            },
            {
                title: '租赁公司',
                dataIndex: '2',
                key: '2',
                width: 250,
                fixed: 'left'
            },
            {
                title: '租金时间（起）',
                dataIndex: '3',
                key: '3',
                width: 150
            },
            {
                title: '租金时间（止）',
                dataIndex: '4',
                key: '4',
                width: 150
            },
            {
                title: '月租金（元）',
                dataIndex: '5',
                key: '5',
                width: 100
            },
            {
                title: '租金交至',
                dataIndex: '6',
                key: '6',
                width: 150
            },
            {
                title: '管理服务费期限（起）',
                dataIndex: '11',
                key: '11',
                width: 180
            },
            {
                title: '管理服务费期限（止）',
                dataIndex: '12',
                key: '12',
                width: 180
            },
            {
                title: '月管理服务费（元）',
                dataIndex: '13',
                key: '13',
                width: 120
            },
            {
                title: '管理服务费交至',
                dataIndex: '14',
                key: '14',
                width: 150
            },
        ];
        return (
            <>
                <Button type="primary" onClick={this.mdchange.bind(this)} icon={<UploadOutlined/>}>导入缴费</Button>
                <Modal title="编辑" maskClosable={false} destroyOnClose={true} width={1200}
                       visible={this.state.visible}
                       onCancel={this.mdchange.bind(this)} footer={null}>
                    <Form
                        layout="vertical"
                        // labelCol={{ span: 3 }}
                        wrapperCol={{span: 24}}
                        autoComplete="off"
                    >
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label={<Space>
                                        <span>上传文件</span>
                                        <a href={'/static/fzjf.xlsx'} target={"_blank"} download>下载模板</a>
                                    </Space>}
                                >
                                    <Row justify="space-between">
                                        <Space align="center">
                                            <Upload
                                                showUploadList={false}
                                                action="/Ajax/upload"
                                                onChange={this.picChange.bind(this, 'url')}
                                                multiple={true}
                                                data={{}}
                                            >
                                                <Button icon={<UploadOutlined/>}>上传</Button>
                                            </Upload>
                                            <Space wrap>
                                                <a href={this.state.condition.url}
                                                   target="_blank">{this.state.condition.filename} </a>
                                            </Space>
                                        </Space>
                                    </Row>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item>
                                    <Row justify={"center"}>
                                        <Button type='primary' onClick={this.sub.bind(this)}
                                                loading={this.state.loading}>导入</Button>
                                    </Row>
                                </Form.Item>
                            </Col>

                            <Alert message={<div dangerouslySetInnerHTML={{
                                __html: `
                                <p>系统提示：</p>
                                <p>1、请确保上传的EXCEL文件和模版一致；</p>
                                <p>2、EXCEL中<span style="color:red">租赁企业、月租金、租金交至、月管理服务费、管理服务费交至</span>这5个字段为重要字段，请确保这5个字段数据的准确性；</p>
                                <p>3、导入后，系统会按照上传EXCEL中的数据，同时更新<span style="color:red">房租</span>和<span style="color:red">管理服务费</span>的缴费记录；</p>
                            `
                            }}></div>} type="warning" style={{width: '100%'}}/>
                            {this.state.list && this.state.list.length ?
                                <Col className="gutter-row" span={24}>
                                    <Table dataSource={this.state.list ? this.state.list : []} columns={columns}
                                           scroll={{x: 1800}}/>
                                </Col>
                                : null}
                        </Row>
                    </Form>
                </Modal>
            </>
        )
    }
}

export default Edit
